import Vue from 'vue'
import Router from 'vue-router'
import huananForecast from '@/components/pc/huananForecast'
import waveForecast from '@/components/pc/waveForecast'
import airportForecast from '@/components/pc/airportForecast'
import Menu from '@/framework/pc/Menu'
import sign from '@/components/pc/sign'
import setting from '@/components/pc/setting'
import hangxian from '@/common/hangxian'
import kepu from '@/common/kepu'
import focastData from '@/common/focastData'
import userInfo from '@/common/userInfo'
import teamIntro from '@/common/teamIntro'
import errorAnalysis from '@/common/errorAnalysis'
import statistics from '@/common/statistics'
import store from '@/store'

Vue.use(Router)

let router = new Router({
  linkActiveClass: 'is-active', //选中导航高亮
  routes: [{
      path: '',
      redirect: '/sign'
    },
    {
      path: '/Menu',
      name: 'Menu',
      component: Menu,
      children: [
        {
          path: '/huananForecast',
          name: 'huananForecast',
          component: huananForecast
        },
        {
          path: '/waveForecast',
          name: 'waveForecast',
          component: waveForecast
        },
        {
          path: '/airportForecast',
          name: 'airportForecast',
          component: airportForecast
        },
        {
            path: '/setting',
            component: setting,
              children: [{
              path: '',
              name: 'hangxian',
              component: hangxian
            },
            {
              path: '/setting/kepu',
              name: 'kepu',
              component: kepu
            },
            {
              path: '/setting/focastData',
              name: 'focastData',
              component: focastData
            },
            {
              path: '/setting/userInfo',
              name: 'userInfo',
              component: userInfo
            },
            {
              path: '/setting/errorAnalysis',
              name: 'errorAnalysis',
              component: errorAnalysis
            },
            {
              path: '/setting/statistics',
              name: 'statistics',
              component: statistics
            },
            {
                path: '/setting/teamIntro',
                name: 'teamIntro',
                component: teamIntro
              }
          ]
          }
      ]
    },
    {
      path: '/sign',
      name: 'sign',
      component: sign,
    },
  ]
})

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};


router.beforeEach((to, from, next) => {
    let userName = localStorage.getItem('userName');
    if (!userName) {
      console.log("需要登陆!");
      if(to.path == '/sign'){
        next();
      }else{
        next('/sign');
      }
    } else {
      store.state.rutePath = to.path;
      if(store.state.map && store.state.map.layers){
        store.state.map.events.unregister('click');
        for (var i = store.state.map.layers.length - 1; i >= 0; i--) {
          if (store.state.map.layers[i].name.indexOf("Tianditu") == -1 && store.state.map.layers[i].name.indexOf("tianDiTuLayer_cva") == -1) {
            store.state.map.removeLayer(store.state.map.layers[i]);
          }
        }
      }
      next();
    }
  })

/**
 * 判断是否为移动设备，是，则跳转到移动端的路径
 */
router.beforeEach((to, from, next) => {
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    window.location.href = '/m_index.html#/'
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/pc/index.js